import type { ReactNode } from 'react';
import { Card } from '@/ui/primitives.js';
import { SOURCES, SOURCE_TOPICS, type SourceTopic } from './sources.js';

/** The reference list, grouped by what each source is used for. */
export function SourcesList(): ReactNode {
  const topics = Object.keys(SOURCE_TOPICS) as SourceTopic[];
  return (
    <div className="space-y-3">
      {topics.map((topic) => (
        <Card key={topic} id={topic} className="scroll-mt-4 space-y-3">
          <h2 className="font-semibold">{SOURCE_TOPICS[topic]}</h2>
          <ul className="space-y-3">
            {SOURCES.filter((s) => s.topic === topic).map((source) => (
              <li key={source.id} className="space-y-0.5">
                <p className="text-sm text-ink-soft">{source.use}</p>
                <a
                  href={source.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-xs text-muted underline"
                >
                  {source.cite}
                </a>
              </li>
            ))}
          </ul>
        </Card>
      ))}
    </div>
  );
}
